import React from 'react';
import './AddParticipantFormPopup.scss';
import Rodal from '../../../../components/Rodal/Rodal';
import { ModalHeader, ModalBody, Button, Col, FormGroup, Row } from 'reactstrap';
import { Form, Field } from '@availity/form';
import * as yup from 'yup';
import ButtonLoader from '../../../../components/Layout/Buttons/ButtonLoader';

interface AddParticipantFormValues {
    name: string;
    role: string;
}

interface AddParticipantFormPopupProps {
    isVisible: boolean;
    onClose: () => void;
    onSubmit: (values: AddParticipantFormValues) => Promise<void>;
    isSubmitting: boolean;
}

const addParticipantSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    role: yup.string().required('Role is required'),
});

const AddParticipantFormPopup = (props: AddParticipantFormPopupProps) => {
    return (
        <div className="add-participant-form-popup">
            {props.isVisible && (
                <Rodal
                    width={550}
                    visible={true}
                    animation={'slideRight'}
                    onClose={props.onClose}
                    center>
                    <ModalHeader>Add New Participant</ModalHeader>
                    <ModalBody className="body_white_box">
                        <Form
                            key="add-participant-form"
                            initialValues={{
                                name: '',
                                role: '',
                            }}
                        validationSchema={addParticipantSchema}
                        onSubmit={async (values: {
                            name: string;
                            role: string;
                        }) => {
                            await props.onSubmit(values);
                        }}>
                        <Col>
                            <FormGroup>
                                <Row>
                                    <Col md={12}>
                                        <label>Name</label>
                                        <Field
                                            type="text"
                                            name="name"
                                            id="name"
                                            className="form-control"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col md={12}>
                                        <label>Role</label>
                                        <Field
                                            type="text"
                                            name="role"
                                            id="role"
                                            className="form-control"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col className="footer">
                            <Button
                                className="cancel btn btn-secondary"
                                onClick={() => props.onClose()}>
                                Cancel
                            </Button>
                            <ButtonLoader
                                type="submit"
                                className="btn btn-primary loader-submit"
                                disabled={props.isSubmitting}
                                isLoading={props.isSubmitting}
                                buttonText="Add Participant"
                                loaderButtonText=""
                                onClick={() => {}}
                            />
                        </Col>
                        </Form>
                    </ModalBody>
                </Rodal>
            )}
        </div>
    );
};

export default AddParticipantFormPopup;
